/* eslint-disable */
import _m0 from "protobufjs/minimal";

export const protobufPackage = "flir_boson_driver";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface AgcMode {
}

export enum AgcMode_Enum {
  kDigitalDetailEnhancement = 0,
  kAdaptiveDetailEnhancement = 1,
  UNRECOGNIZED = -1,
}

export function agcMode_EnumFromJSON(object: any): AgcMode_Enum {
  switch (object) {
    case 0:
    case "kDigitalDetailEnhancement":
      return AgcMode_Enum.kDigitalDetailEnhancement;
    case 1:
    case "kAdaptiveDetailEnhancement":
      return AgcMode_Enum.kAdaptiveDetailEnhancement;
    case -1:
    case "UNRECOGNIZED":
    default:
      return AgcMode_Enum.UNRECOGNIZED;
  }
}

export function agcMode_EnumToJSON(object: AgcMode_Enum): string {
  switch (object) {
    case AgcMode_Enum.kDigitalDetailEnhancement:
      return "kDigitalDetailEnhancement";
    case AgcMode_Enum.kAdaptiveDetailEnhancement:
      return "kAdaptiveDetailEnhancement";
    case AgcMode_Enum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

function createBaseAgcMode(): AgcMode {
  return {};
}

export const AgcMode = {
  encode(_: AgcMode, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): AgcMode {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAgcMode();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): AgcMode {
    return {};
  },

  toJSON(_: AgcMode): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<AgcMode>, I>>(base?: I): AgcMode {
    return AgcMode.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AgcMode>, I>>(_: I): AgcMode {
    const message = createBaseAgcMode();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };
